import { createContext } from 'react'
interface HomeStateContextType {
  isOnline?: boolean
  hasMonitorAccessEnabled?: boolean
  isLoading: boolean
}

const initHomeStateContext: HomeStateContextType = {
  isOnline: undefined,
  hasMonitorAccessEnabled: undefined,
  isLoading: false,
}

export const HomeStateContext =
  createContext<HomeStateContextType>(initHomeStateContext)
